const email = "colin@harrisonsoftwarellc.com";

export default function Contact() {
  return (
    <section className="contact section" id="contact">
      <div className="section-wrap contact__inner">
        <div>
          <p className="eyebrow">Have a project in mind?</p>
          <h2>Let’s make something useful.</h2>
          <p className="contact__intro">
            Share what you’re building, what needs attention, or where your team could use an extra engineering hand.
          </p>
        </div>
        <div className="contact__actions">
          <a
            className="button button--light"
            href={"mailto:" + email + "?subject=Software%20project%20inquiry"}
          >
            Email Colin <span aria-hidden="true">↗</span>
          </a>
          <a className="contact__email" href={"mailto:" + email}>{email}</a>
        </div>
        <div className="contact__socials">
          <a href="https://www.linkedin.com/in/colin-h-23007a279/" target="_blank" rel="noopener noreferrer">LinkedIn ↗</a>
          <a href="https://github.com/Boomup25" target="_blank" rel="noopener noreferrer">GitHub ↗</a>
        </div>
      </div>
    </section>
  );
}
